import { Card } from '@ui/card';
import styles from './index.module.sass';
import { Market, SimplePrice } from '@@/mixing/ts/analytic.types';
import { formatPrice as fp } from '@/modules/common/utils/price-formatters.util';
import cn from 'classnames';
import { Skeleton } from 'antd';
import { UniversalLoader } from '@/modules/common/components/universal-loader';

export function PriceCard(props: IPriceCard) {
  const {
    market,
    price,
    isTonPrice,
    description,
    priceDescription,
    icon,
    header,
    className,
    headerStyle,
    button,
    additionalValue,
    profit,
    loading,
  } = props;
  // console.log(+String(profit).replaceAll(/\D/g, ''));

  return (
    <Card className={cn(styles.root, className)}>
      {/* { !loading && <UniversalLoader title={<span>подождите, пожалуйста несколько секунд. <br/> Идет пересчет стоимостей</span>}/>} */}
      {loading ? (
        <UniversalLoader
          title={
            <span>
              подождите, пожалуйста несколько секунд. <br /> Идет пересчет стоимостей
            </span>
          }
        />
      ) : (
        <div className={styles.body}>
          <div className={styles.header}>
            <div>{<img src={icon} />}</div>
            <div
              className={cn(styles.smallText, headerStyle)}
              dangerouslySetInnerHTML={{ __html: header as string }}
            ></div>
          </div>
          <div className={styles.description}>
            <span className={styles.text}>{description}</span>
            {Number(profit) > 0 && (
              <span className={styles.profit}>
                <span>выгода от микса</span>
                {profit?.toLocaleString('ru', { maximumFractionDigits: 0 }) + ' ₽'}
              </span>
            )}
          </div>
          {additionalValue && (
            <div className={cn(styles.description, styles.additional)}>
              {additionalValue}
            </div>
          )}
          <div className={cn(styles.pdescription, styles.bold)}>{priceDescription}</div>
          <div>
            {market ? (
              <table className={styles.gradeTable}>
                <thead>
                  <tr>
                    {Object.values(market)
                      .filter((v) => typeof v == 'object')
                      .map((v: any, i) => (
                        <td key={i}>{v.name}</td>
                      ))}
                  </tr>
                </thead>
                <tbody className={styles.bold}>
                  <tr>
                    {Object.values(market)
                      .filter((v) => typeof v == 'object')
                      .map((v: any, i) => (
                        <td key={i}>{fp(v.price)}</td>
                      ))}
                  </tr>
                </tbody>
              </table>
            ) : button ? (
              <div className={styles.priceAndButton}>
                <div className={cn(styles.bold, styles.priceTag)}>
                  <span className={styles.profit}>
                    {price && fp(price)} {isTonPrice ? '₽/т' : '₽'}
                  </span>
                </div>
                <div className={cn(styles.bold, styles.priceTag)}>{button}</div>
              </div>
            ) : (
              <div className={cn(styles.bold, styles.priceTag)}>
                <span className={styles.profit}>
                  {price && fp(price)} {isTonPrice ? '₽/т' : '₽'}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </Card>
  );
}

export interface IPriceCard {
  button?: JSX.Element;
  price?: number | string;
  isTonPrice?: boolean;
  description: string | JSX.Element;
  priceDescription?: string;
  icon?: string;
  header?: string;
  benefits?: number;
  market?: Market;
  className?: string;
  headerStyle?: string;
  additionalValue?: string;
  profit?: number | string;
  loading: boolean;
}
